import { getArticles } from '@/graphql/queries/media/article';

export default async ({ $apolloQuery, store }) => {
  const blogs = store.getters['blog/getNavArticles'];
  if (blogs.length) return;
  await $apolloQuery(getArticles, { per: 4 }).then(result => store.commit('blog/setNavArticles', result.articles));
};
